__turbopack_context__.v({
  "content": "illustrationRow-module-scss-module__3UvPIa__content",
  "illustration": "illustrationRow-module-scss-module__3UvPIa__illustration",
  "illustrationRowItem": "illustrationRow-module-scss-module__3UvPIa__illustrationRowItem",
});
